import { type OriginAnalyticsAttributes } from '@atlassiansox/origin-tracing/types';

export enum GrowthPillar {
	FIND = 'FIND',
	BUY = 'BUY',
	USE = 'USE',
	PLATFORM = 'PLATFORM',
}

export type ExperimentCohortVariationControl = 'variation' | 'control' | 'not-enrolled';

/**
 * SELECTION - This is used to represent when the user is required to select an edition.
 */
export enum Edition {
	FREE_EDITION = 'free',
	STANDARD_EDITION = 'standard',
	PREMIUM_EDITION = 'premium',
	SELECTION = 'selection',
}

export type FeatureId = 'edition-awareness' | 'admin-tools-upsell' | 'issue-permissions';

export type ExperimentMeta = {
	[other: string]: any;
	cohort: string;
	key: string;
};

export type Experiments = {
	[experimentKey: string]: {
		[other: string]: any;
		cohort: string;
		timestamp: number;
	};
};

export type ExperimentsMeta = ExperimentMeta[];

export type TouchpointContext = {
	experimentMeta?: ExperimentMeta[];
	experiments?: Experiments;
	featureId: FeatureId;
};

type TouchpointSharedAttributes = {
	experimentMeta?: ExperimentMeta;
	experiments?: Experiments;
	growthPillar: GrowthPillar;
};

// if a touchpoint intent has it's own dedicated type, we will exclude it here
export type TouchpointIntent =
	| 'addPaymentDetails'
	| 'downgrade'
	| 'startTrial'
	| 'onboarding'
	| 'changePlan'
	| 'directBuy'
	| 'deactivate';
interface TouchpointCommonAttributes extends TouchpointSharedAttributes {
	currentProductEdition?: Edition;
	href?: string;
	targetProductEdition?: Edition;
	touchpointIntent: TouchpointIntent;
}

export type TouchpointAttributes = TouchpointCommonAttributes & Partial<OriginAnalyticsAttributes>;
